import React, { useEffect, useMemo, useState } from "react";
import "./Home.scss";
import { getAllAppAPI, activeAppAPI } from "../api/ClientApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch } from "react-redux";
import { handleLogoutRedux } from "../../redux/actions/userAction";
import { toast } from "react-toastify";
import { Confirm } from "react-admin";
import {
  AppsIcon,
  DevicesIcon,
  CheckCircleIcon,
  PlusIcon,
  PencilIcon,
  SendIcon,
  SettingsIcon,
  ClockIcon,
} from "../icons";

const FILTERS = [
  { id: "all", label: "Tất cả" },
  { id: "ios", label: "iOS" },
  { id: "android", label: "Android" },
  { id: "active", label: "Active" },
];

const AppAvatar = ({ name, iconUrl }) => {
  const [failed, setFailed] = useState(false);
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";

  if (!iconUrl || failed) {
    return <div className="app-row__avatar app-row__avatar--fallback">{initial}</div>;
  }

  return (
    <img
      className="app-row__avatar"
      src={iconUrl}
      alt=""
      onError={() => setFailed(true)}
    />
  );
};

const Home = () => {
  const [listApps, setListApps] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [position, setPosition] = useState(-1);
  const [reload, setReload] = useState(true);
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  const history = useHistory();
  const dispatch = useDispatch();

  const handleDialogClose = () => {
    setShowAlert(false);
    setPosition(-1);
  };

  const handleConfirm = () => {
    setShowAlert(false);
    const { app_id, is_active } = listApps[position];
    setPosition(-1);
    activeAppAPI({
      appId: app_id,
      isActive: is_active === 1 ? 0 : 1,
    }).then((response) => {
      let { errorCode, message } = response;
      if (errorCode === 0) {
        setReload(true);
        toast.success(message);
        history.push("/admin");
      } else if (errorCode === 401) {
        toast.error(message);
        dispatch(handleLogoutRedux());
      } else {
        toast.error(message);
      }
    });
  };

  const handleOnChange = (index) => {
    const { is_active } = listApps[index];
    setPosition(index);
    if (is_active === 1) {
      setMessage(`Xác nhận bỏ Active ứng dụng`);
      setShowAlert(true);
    }
    if (is_active === 0) {
      setMessage(`Xác nhận mở Active ứng dụng`);
      setShowAlert(true);
    }
  };

  useEffect(() => {
    if (reload) {
      setLoading(true);
      getAllAppAPI().then((response) => {
        setReload(false);
        setLoading(false);
        const { errorCode, message } = response;
        if (errorCode === 0) {
          setListApps(response.data);
          let updatedCheckedState = new Array(response.data.length).fill(false);
          updatedCheckedState = updatedCheckedState.map((item, index) =>
            response.data[index].is_active === 1 ? !item : item
          );
          setCheckedState(updatedCheckedState);
        } else if (errorCode === 401) {
          dispatch(handleLogoutRedux());
        } else {
          toast.error(message);
        }
      });
    }
  }, [reload, dispatch]);

  const totalApps = listApps.length;
  const iosCount = listApps.filter((app) => app.os === "ios").length;
  const androidCount = listApps.filter((app) => app.os === "android").length;
  const activeCount = listApps.filter((app) => app.is_active === 1).length;

  const filteredApps = useMemo(() => {
    const q = query.trim().toLowerCase();
    return listApps
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => {
        if (filter === "ios" && item.os !== "ios") return false;
        if (filter === "android" && item.os !== "android") return false;
        if (filter === "active" && item.is_active !== 1) return false;
        if (!q) return true;
        return (
          (item.app_name || "").toLowerCase().includes(q) ||
          (item.app_id || "").toLowerCase().includes(q) ||
          (item.bundle_id || "").toLowerCase().includes(q)
        );
      });
  }, [listApps, query, filter]);

  return (
    <div className="page-container app-manager">
      <div className="page-header">
        <div>
          <h1 className="page-title">App Manager</h1>
          <p className="page-subtitle">
            Quản lý các app đã đăng ký và trạng thái hoạt động.
          </p>
        </div>
        <button
          className="btn btn-primary d-flex align-items-center gap-2"
          onClick={() => {
            history.push("/createApp");
          }}
        >
          <PlusIcon width={16} height={16} />
          Create New App
        </button>
      </div>

      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-card-icon">
            <AppsIcon />
          </div>
          <div>
            <div className="stat-card-value">{totalApps}</div>
            <div className="stat-card-label">Tổng số app</div>
          </div>
        </div>
        <div className="stat-card stat-card--info">
          <div className="stat-card-icon">
            <DevicesIcon />
          </div>
          <div>
            <div className="stat-card-value">{iosCount}</div>
            <div className="stat-card-label">App iOS</div>
          </div>
        </div>
        <div className="stat-card stat-card--warning">
          <div className="stat-card-icon">
            <DevicesIcon />
          </div>
          <div>
            <div className="stat-card-value">{androidCount}</div>
            <div className="stat-card-label">App Android</div>
          </div>
        </div>
        <div className="stat-card stat-card--success">
          <div className="stat-card-icon">
            <CheckCircleIcon />
          </div>
          <div>
            <div className="stat-card-value">{activeCount}</div>
            <div className="stat-card-label">Đang Active</div>
          </div>
        </div>
      </div>

      <div className="app-manager__toolbar">
        <input
          type="search"
          className="form-control app-manager__search"
          placeholder="Tìm theo tên, app id hoặc bundle id…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <div className="app-manager__filters">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              type="button"
              className={`app-manager__chip${filter === f.id ? " is-active" : ""}`}
              onClick={() => setFilter(f.id)}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="app-manager__list">
        {loading && (
          <div className="empty-state">Đang tải danh sách app…</div>
        )}

        {!loading &&
          filteredApps.map(({ item, index }) => {
            const isActive = item.is_active === 1;
            return (
              <div
                key={item.app_id || index}
                className={`app-row${isActive ? "" : " app-row--inactive"}`}
              >
                <div className="app-row__main">
                  <AppAvatar name={item.app_name} iconUrl={item.icon_url} />
                  <div className="app-row__meta">
                    <div className="app-row__title-line">
                      <span className="app-row__name">{item.app_name}</span>
                      <span
                        className={`badge rounded-pill text-bg-${
                          item.os === "ios" ? "info" : "warning"
                        }`}
                      >
                        {item.os}
                      </span>
                      {isActive ? (
                        <span className="badge rounded-pill text-bg-success">Active</span>
                      ) : (
                        <span className="badge rounded-pill text-bg-secondary">Inactive</span>
                      )}
                    </div>
                    <div className="app-row__id">{item.app_id}</div>
                    <div className="app-row__bundle">{item.bundle_id}</div>
                  </div>
                </div>

                <div className="app-row__side">
                  <div className="app-row__firebase">
                    <span
                      className={`badge rounded-pill text-bg-${
                        item.has_firebase_credential ? "success" : "secondary"
                      }`}
                    >
                      Prod
                    </span>
                    <span
                      className={`badge rounded-pill text-bg-${
                        item.has_firebase_credential_sandbox ? "success" : "secondary"
                      }`}
                    >
                      Sandbox
                    </span>
                  </div>

                  <div className="app-row__actions">
                    <button
                      className="icon-btn"
                      title="Edit app"
                      onClick={() => history.push("/editApp", item)}
                    >
                      <PencilIcon width={16} height={16} />
                    </button>
                    <button
                      className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                      onClick={() => history.push("/push", item)}
                    >
                      <SendIcon width={14} height={14} />
                      Push
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                      onClick={() => history.push("/push-schedule", item)}
                    >
                      <ClockIcon width={14} height={14} />
                      Lịch
                    </button>
                    <button
                      className="icon-btn"
                      title="App config"
                      onClick={() => history.push("/app-config", item)}
                    >
                      <SettingsIcon width={16} height={16} />
                    </button>
                    <div className="form-check form-switch mb-0 app-row__switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={`app-active-${index}`}
                        checked={!!checkedState[index]}
                        onChange={() => handleOnChange(index)}
                        title={isActive ? "Bỏ Active" : "Mở Active"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

        {!loading && listApps.length === 0 && (
          <div className="empty-state">
            Chưa có app nào — bấm &quot;Create New App&quot; để bắt đầu.
          </div>
        )}

        {!loading && listApps.length > 0 && filteredApps.length === 0 && (
          <div className="empty-state">Không có app khớp bộ lọc hiện tại.</div>
        )}
      </div>

      <Confirm
        isOpen={showAlert}
        loading={false}
        title=""
        content={message}
        confirm="Đồng ý"
        confirmColor="primary"
        cancel="Huỷ bỏ"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </div>
  );
};

export default Home;
